'use client';
import { ChartNoAxesCombined, ShoppingCart, User, X } from 'lucide-react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { userActions } from '@store/actions';
import { userSelector } from '@store/user/user.slice';
import { cn } from '@utils/index';

function useBodyScrollLock(lock: boolean) {
  useEffect(() => {
    if (lock) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [lock]);
}

export default function ProfileSider() {
  const dispatch = useDispatch();
  const { showProfileSider } = useSelector(userSelector);
  const pathname = usePathname();

  const menus = [
    {
      href: '/ho-so/ca-nhan',
      icon: <User className="w-5 h-5" strokeWidth={2.5} />,
      label: 'Thông tin cá nhân',
    },
    {
      href: '/ho-so/don-hang',
      icon: <ShoppingCart className="w-5 h-5" strokeWidth={2.5} />,
      label: 'Quản lý đơn hàng',
    },
    {
      href: '/ho-so/bao-gia',
      icon: <ChartNoAxesCombined className="w-5 h-5" strokeWidth={2.5} />,
      label: 'Báo giá',
    },
  ];

  useBodyScrollLock(showProfileSider);

  const pathWithoutLocale = pathname?.replace(/^\/(vi|en)/, '');

  return (
    <>
      <div
        onClick={() => dispatch(userActions.self.setShowProfileSider(false))}
        className={cn(
          'fixed inset-0 z-[9] lg:hidden bg-black/40 backdrop-blur-sm transition-all duration-300',
          showProfileSider ? 'opacity-100 visible' : 'opacity-0 invisible'
        )}
      />
      <div
        className={cn('absolute lg:relative !h-screen z-10 bg-white', {
          'w-0 lg:w-auto': !showProfileSider,
        })}
      >
        {/* Sidebar */}
        <aside
          className={`
        !h-full inset-y-0 left-0 z-0 w-64  border-r border-orange-100 transform transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-0
        ${showProfileSider ? 'translate-x-0 bg-orange-50/20' : '-translate-x-full bg-white'}
      `}
        >
          <div className="flex flex-col md:!sticky md:top-[40px]">
            {/* Mobile close button */}
            <button
              onClick={() => dispatch(userActions.self.setShowProfileSider(false))}
              className="p-2 bg-gray-200/50  text-orange-600 lg:hidden absolute top-2 right-2 rounded-full"
            >
              <X strokeWidth={3} className="w-3 h-3 font-bold" />
            </button>

            <div className="flex flex-col p-4 space-y-6">
              <nav className="space-y-2 mt-6">
                {menus.map((menu, index) => (
                  <Link
                    key={index}
                    href={menu.href}
                    onClick={() => dispatch(userActions.self.setShowProfileSider(false))}
                    className={`flex items-center space-x-2 px-4 py-3 rounded-lg transition-colors font-medium
                    ${
                      pathWithoutLocale === menu?.href || pathname?.includes(menu?.href)
                        ? 'bg-orange-500 text-white'
                        : 'text-gray-800 bg-slate-50 hover:bg-slate-100'
                    }
                  `}
                  >
                    {menu.icon}
                    <span className="font-[600]">{menu.label}</span>
                  </Link>
                ))}
              </nav>
            </div>
          </div>
        </aside>
      </div>
    </>
  );
}
